import React from 'react';
import { Card } from '../ui/Card';
import { useLanguage } from '@/state/language/LanguageProvider';

interface PlaceholderPageProps {
  title: string;
  description: string;
  features?: string[];
  comingSoon?: boolean;
}

const PlaceholderPage: React.FC<PlaceholderPageProps> = ({ 
  title, 
  description, 
  features = [],
  comingSoon = true 
}) => {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen bg-[var(--color-surface-bg)] p-6">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-[var(--color-surface-text)] mb-2">{title}</h1>
          <p className="text-[var(--color-surface-text)] text-lg">{description}</p>
        </div>

        <Card className="p-8">
          {comingSoon && (
            <div className="text-center mb-8">
              <div className="inline-flex items-center px-4 py-2 bg-[var(--color-info)] bg-opacity-20 text-[var(--color-info)] rounded-full text-sm font-medium mb-4">
                <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                </svg>
                {t('common.comingSoon')}
              </div>
              <p className="text-[var(--color-surface-text)]">
                {t('common.underDevelopment')}
              </p>
            </div>
          )}

                    {features.length > 0 && (
            <div className="mb-8">
              <h2 className="text-xl font-semibold text-[var(--color-surface-text)] mb-4">{t('common.plannedFeatures')}</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {features.map((feature, index) => (
                  <div key={index} className="flex items-start">
                    <div className="flex-shrink-0">
                      <svg className="w-5 h-5 text-[var(--color-success)] mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <p className="ml-3 text-[var(--color-surface-text)]">{feature}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="bg-[var(--color-secondary-bg)] bg-opacity-20 rounded-lg p-6">
            <h3 className="text-lg font-medium text-[var(--color-surface-text)] mb-2">{t('common.whatsNext')}</h3>
            <p className="text-[var(--color-surface-text)] mb-4">
              {t('common.incrementalDevelopment')}
            </p>
            <div className="flex flex-wrap gap-2">
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[var(--color-info)] bg-opacity-20 text-[var(--color-info)]">
                {t('common.phase1')}
              </span>
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[var(--color-success)] bg-opacity-20 text-[var(--color-success)]">
                {t('common.phase2')}
              </span>
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[var(--color-accent-bg)] bg-opacity-20 text-[var(--color-accent-text)]">
                {t('common.phase3')}
              </span>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default PlaceholderPage;
